/** Walk up from `el` to the nearest ancestor that scrolls vertically. */
export function findScrollParent(el: HTMLElement, win: Window): HTMLElement | null {
	let node: HTMLElement | null = el.parentElement;
	while (node) {
		const { overflowY } = win.getComputedStyle(node);
		if (overflowY === 'auto' || overflowY === 'scroll') return node;
		node = node.parentElement;
	}
	return null;
}
